<template>
  <div class="input-wrapper hd">
    <div class="input-box">
      <span class="name">所属平台：</span>
      <div class="input">
        <el-select :disabled="$store.state.entryType === 'seller'" v-model="condition.platformId" placeholder="请选择"
          clearable>
          <el-option :label="item.label" :value="item.value" :key="item.value"
            v-for="item in filterDownData('platformList')" />
        </el-select>
      </div>
    </div>
    <div class="input-box">
      <span class="name">订单归属商家：</span>
      <div class="input">
        <el-select :disabled="$store.state.entryType === 'seller'" v-model="condition.orderAttribution" placeholder="请选择"
          clearable>
          <el-option :label="item.label" :value="item.value" :key="item.value"
            v-for="item in filterDownData('merchantList')" />
        </el-select>
      </div>
    </div>
    <div class="input-box">
      <span class="name">所属小程序：</span>
      <div class="input">
        <el-select v-model="condition.appletsId" placeholder="请选择" clearable>
          <el-option :label="item.label" :value="item.value" :key="item.value" v-for="item in filterApplet" />
        </el-select>
      </div>
    </div>
    <div class="input-box">
      <span class="name">商品名称：</span>
      <div class="input">
        <el-input v-model="condition.name" placeholder="请输入" clearable />
      </div>
    </div>
    <div class="input-box">
      <span class="name">商品SKU编码：</span>
      <div class="input">
        <el-input v-model="condition.sku" placeholder="请输入" clearable />
      </div>
    </div>
    <div class="input-box">
      <span class="name">销售价格：</span>
      <div class="input">
        <el-input v-model="condition.price" placeholder="请输入" clearable />
      </div>
      至
      <div class="input">
        <el-input v-model="condition.priced" placeholder="请输入" clearable />
      </div>
    </div>
    <div class="input-box">
      <span class="name">商品类目：</span>
      <div class="input">
        <el-cascader v-model="condition.goodsCategoray" :options="filterDownData('classList').options" clearable />
      </div>
    </div>
    <div class="input-box">
      <span class="name">会员等级：</span>
      <div class="input">
        <el-select v-model="condition.vipLevel" placeholder="请选择" clearable>
          <el-option v-for="item in filterDownData('levelList')" :key="item.value" :value="item.value"
            :label="item.label" />
        </el-select>
      </div>
    </div>
    <div class="input-box">
      <span class="name">商品分类：</span>
      <div class="input">
        <el-select v-model="condition.goodsType" placeholder="请选择" clearable>
          <el-option value="1" label="完税" />
          <el-option value="2" label="跨境" />
          <el-option value="3" label="期酒" />
          <el-option value="5" label="直邮" />
        </el-select>
      </div>
    </div>
    <div class="input-box datepick">
      <span class="name">上架时间：</span>
      <div class="input ">
        <el-date-picker v-model="condition.time" type="daterange" unlink-panels range-separator="至"
          format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期"
          :picker-options="pickerOptions" clearable />
      </div>
    </div>
    <el-button size="60" round class="iconfont icon-sousuo" @click="searchData" />
  </div>
</template>
<script>
import pickerOptions from 'mixins/pickerOptions/'
import filterDownData from 'mixins/filterDownData'

export default {
  name: 'SearchComponent',
  mixins: [pickerOptions, filterDownData],
  props: {
    condition: {
      type: Object
    },
    type: {
      type: String
    },
    switchParamsType: {
      type: Function
    }
  },
  computed: {
    filterApplet() {
      if (this.$store.state.entryType === 'seller') {
        this.condition.orderAttribution = this.$store.state.merchantId
        this.condition.platformId = this.$store.state.platformId
      }
      const applets = this.filterDownData('appletsList').filter(v => {
        return v.merchantId === this.condition.orderAttribution
      })
      this.condition.appletsId = ''
      return applets
    }
  },
  methods: {
    /**
     * 筛选数据
     */
    searchData() {
      const type = this.type
      const condition = this._returnSearchCondition()
      this.$emit(
        'updateData',
        vm => {
          let params = vm._switchParamsType(vm.activeName)
          Object.assign(condition, params)
          vm._getGoodsList(condition, type)
        },
        '',
        type
      )
    },
    /**
     * 返回搜索条件
     */
    _returnSearchCondition() {
      const {
        name,
        sku,
        goodsCategoray,
        price,
        priced,
        time,
        vipLevel,
        appletsId,
        storeCategoray,
        goodsType,
        orderAttribution,
        platformId
      } = this.condition
      const condition = {
        order_merchant_id: orderAttribution,
        goods_name: name,
        goods_sku: sku,
        start_price: price,
        end_price: priced,
        applet_id: appletsId,
        goods_type: goodsType,
        start_time: time[0] || '',
        end_time: time[1] || '',
        class_id: goodsCategoray.slice(-1)[0] || '',
        level_id: vipLevel,
        merchant_class_id: storeCategoray.slice(-1)[0] || '',
        platform_id: platformId
      }
      this.utils._checkSearchCondition(condition)
      return condition
    }
  }
}
</script>
